__turbopack_context__.v({
  "className": "fontawesome6pro_e54f52d9-module__01h9zq__className",
  "variable": "fontawesome6pro_e54f52d9-module__01h9zq__variable",
});
